import type { SVGProps } from "react";

const SvgAerzteApothekerbankSmallLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="15.0 15.0 482.1 482.1"
    fill="none"
    {...props}
  >
    <path
      fill="#D40026"
      d="M252.878 55h-10.613c-18.627 1.476-37.346 9.338-49.286 24.094-14.323 15.865-19.778 39.179-13.975 59.75 2.495 8.668 6.782 16.562 11.068 24.45 2.294 4.224 4.588 8.448 6.606 12.788 39.918 77.076 79.985 154.089 119.783 231.218 1.381 2.423 2.677 4.915 3.975 7.406 3.678 7.061 7.367 14.144 13.003 19.865 12.474 12.688 29.452 20.916 47.22 22.429h11.686c17.822-1.581 34.866-9.998 47.328-22.754 9.663-10.798 16.12-24.643 17.327-39.153V384.41c-.818-8.239-2.935-16.4-6.794-23.754-44.474-85.938-89.043-171.829-133.571-257.735-4.771-9.584-9.608-19.368-17.381-26.92C287.409 63.08 270.057 56.527 252.878 55M154.843 260.847c-7.409-19.242-12.314-40.519-7.692-61.022-28.125 45.947-55.408 92.596-77.692 141.72-5.95 14.311-12.355 28.727-14.459 44.22v8.831c1.179 14.028 7.396 27.308 16.389 38.028 13.145 14.363 31.984 23.141 51.388 24.376h12.878c19.523-1.34 38.564-9.893 52.233-23.921 11.082-12.301 18.719-28.465 18.103-45.277-.847-13.751-5.834-26.711-10.733-39.436l-.67-1.743c-6.089-14.829-13.131-29.219-20.172-43.613-6.812-13.924-13.623-27.847-19.573-42.163"
    />
  </svg>
);
export default SvgAerzteApothekerbankSmallLogo;
